module.exports = {
  back: 'Volver',
};
